<div class="blogs_content">
<div class="row">
  <div class="col-md-12">
    <div class="left_div">
      <div class="title text-left w-100">{{blogdetails?.MetaTitle}}</div>
    </div>
    <div class="education_content mt-4">
      <!-- <div class="">{{blogdetails?.MetaKeyword}}</div> -->
      <div class="">{{blogdetails?.dateCreated}}</div>
    </div>
    <div class="pancil_img_content mt-4">
      <div *ngFor="let dt of blogdetails?.files">
        <img *ngIf="dt.type=='OtherFiles'" src={{dt.url}} loading="lazy" width="100%" height="100%" class="img img-responsive" alt={{dt.filename}}>
      </div>      
      <div class="text_para mt-3">
        <p>{{blogdetails?.Short}}</p>
      </div>
    </div>

    <div class="text_para mt-3">
      <img src="../../../../assets/img/new-kidzee/btrfly_img.png" class="btrfly_img_content" alt="">
      <!-- <img src="../../../../assets/img/new-kidzee/chocolate_img.png" class="chocolate_img_content" alt=""> -->
      <img src="../../../../assets/img/new-kidzee/fruit_img.png" class="fruit_img_content" alt="">
      <img src="../../../../assets/img/new-kidzee/mouse_img.png" class="mouse_img_content" alt="">
      <img src="../../../../assets/img/new-kidzee/fish_img.png" class="fish_img_content" alt="">
     
      <p [innerHTML]="blogdetails?.long1"></p>
      <!-- <img src="../../../../assets/img/new-kidzee/chocolate_img.png" class="chocolate_img" alt=""> -->
    </div>
  </div>
</div>
</div>
<!-- <div class="mainDiv5">
  <app-faqs ></app-faqs>
</div> -->
<app-faqs ></app-faqs>
<img src="../../../../assets/img/new-kidzee/btrfly_img.png" class="btrfly_img_content" alt="">
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
